module.exports = __webpack_public_path__ + "assets/vehicle_map_truck.5e5288b1.svg";